import { createSlice } from '@reduxjs/toolkit';

export interface ProductInfoState {
  isCartModalOpen: boolean;
}

export const initialState: ProductInfoState = {
  isCartModalOpen: false,
};
export interface TrackDeliveryBlockLocationSelectionPayload {
  fromLocation: string;
  toLocation: string;
}

export const { reducer, actions } = createSlice({
  name: 'productInfo',
  initialState,
  reducers: {
    openCartModal: (state) => {
      state.isCartModalOpen = true;
    },
    closeCartModal: (state) => {
      state.isCartModalOpen = false;
    },
    onBuyGiftCard: () => {},
    onCartContinueShopping: () => {},
    onCartGoToBasket: () => {},
  },
});
